import React from 'react';
import { HandleExceptionErrorPage } from 'views/pages/errors/HandleExceptionErrorPage';

type ErrorBoundaryProps = {
  children?: React.ReactNode;
};
type ErrorBoundaryState = {
  error?: Error;
  componentStack?: string;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined, componentStack: undefined };
  }

  componentDidCatch(e: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      error: e,
      componentStack: errorInfo.componentStack ?? undefined,
    });
  }

  render(): React.ReactNode {
    const { error, componentStack } = this.state;

    if (error) {
      return (
        <HandleExceptionErrorPage
          error={error}
          componentStack={componentStack}
        />
      );
    }

    return this.props.children;
  }
}
